<template>
    <div class="subbanner">
        <div class="subbanner-container">
            <div class="subbanner_img">
                <img src="@/assets/VictoriaHarbourEvening.jpg" alt="banner image">
                <div class="mask"></div>
                <div class="subbanner_content">
                    <div>
                        <h1>{{ text }}</h1>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props:{
            text:String,
        }
    }
</script>

<style lang="less" scoped>
    @import "./style.less" ;
</style>